import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
	resetUpdateWalletDetails,
	updateWalletDetailsReq
} from "../../redux/actions/updateoraddwalletownerbankdetailsAction";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const AddBankDetails = () => {
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const dispatch = useDispatch();
	const [BankName, setBankName] = useState("");
	const [currency, setCurrency] = useState("");
	const [accountNumber, setAccountNumber] = useState("");
	const [SFBCode, setSFBCode] = useState("");
	const [sortCode, setSortCode] = useState("");
	const [routingCode, setRoutingCode] = useState("");
	const [IBANNumber, setIBANNumber] = useState("");
	const [accountHolder, setAccountHolder] = useState("");
	const [bankCountry, setBankCountry] = useState("");
	const [bankAddress, setBankAddress] = useState("");
	const [zipCode, setZipCode] = useState("");
	const [bcontactNumber, setBContactNumber] = useState("");
	const [BcontactPerson, setBcontactPerson] = useState("");
	const [isBankDefault, setIsBankDefault] = useState("");
	const [updateoraddwalletownerArray, setUpdateoraddwalletownerArray] =
		useState("");
	const [updatewalletpopup, setupdatewalletpopup] = useState(false);
	const [updatewalletstatus, setupdatewalletstatus] = useState(false);

	// const handleChange = ({ target: { name, value } }) => {
	//   if (name === "BcontactPerson") {
	//     setBcontactPerson(value);
	//   }

	//   if (name === "currency") {
	//     // setCurrency(value);
	//     setCurrency(value == "Select Currency" ? "" : value);
	//   }

	//   if (name === "BankName") {
	//     setBankName(value);
	//   }

	//   if (name === "accountNumber") {
	//     setAccountNumber(value);
	//   }

	//   if (name === "accountNumber") {
	//     setAccountNumber(value);
	//   }

	//   if (name === "SFBCode") {
	//     setSFBCode(value);
	//   }

	//   if (name === "sortCode") {
	//     setSortCode(value);
	//   }

	//   if (name === "routingCode") {
	//     setRoutingCode(value);
	//   }

	//   if (name === "IBANNumber") {
	//     setIBANNumber(value);
	//   }

	//   if (name === "accountHolder") {
	//     setAccountHolder(value);
	//   }

	//   if (name === "bankCountry") {
	//     setBankCountry(value);
	//   }

	//   if (name === "bankAddress") {
	//     setBankAddress(value);
	//   }

	//   if (name === "zipCode") {
	//     setZipCode(value);
	//   }

	//   if (name === "bcontactNumber") {
	//     setBContactNumber(value);
	//   }

	//   if (name === "isBankDefault") {
	//     //  setIsBankDefault(value);
	//     setIsBankDefault(value == "Select Status" ? "" : value);
	//   }
	// };

	const handleChange = ({ target: { name, value } }) => {
		// if (name === "BankId") {
		//   setBankId(value);
		// }

		if (name === "BcontactPerson") {
			// setBcontactPerson(value);
			Util.verifyAlphabet(value)
				? setBcontactPerson(value)
				: setBcontactPerson(BcontactPerson);
		}

		// if (name === "bankname") {
		//   // setbankname(value);
		//   Util.alphaNumeric(value) ? setbankname(value) : setbankname(bankname);
		// }

		if (name === "currency") {
			//setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "BankName") {
			// setBankName(value);
			Util.alphaNumeric(value) ? setBankName(value) : setBankName(BankName);
		}

		if (name === "accountNumber") {
			// setAccountNumber(value);
			Util.verifyMobile(value)
				? setAccountNumber(value)
				: setAccountNumber(accountNumber);
		}

		// if (name === "accountNumber") {
		//   setAccountNumber(value);
		// }

		if (name === "SFBCode") {
			// setSFBCode(value);
			Util.alphaNumeric(value) ? setSFBCode(value) : setSFBCode(SFBCode);
		}

		if (name === "sortCode") {
			// setSortCode(value);
			Util.verifyMobile(value) ? setSortCode(value) : setSortCode(sortCode);
		}

		if (name === "routingCode") {
			// setRoutingCode(value);
			Util.verifyMobile(value)
				? setRoutingCode(value)
				: setRoutingCode(routingCode);
		}

		if (name === "IBANNumber") {
			// setIBANNumber(value);
			Util.verifyMobile(value)
				? setIBANNumber(value)
				: setIBANNumber(IBANNumber);
		}

		if (name === "accountHolder") {
			// setAccountHolder(value);
			Util.verifyAlphabet(value)
				? setAccountHolder(value)
				: setAccountHolder(accountHolder);
		}

		if (name === "bankCountry") {
			// setBankCountry(value);
			Util.verifyAlphabet(value)
				? setBankCountry(value)
				: setBankCountry(bankCountry);
		}

		if (name === "bankAddress") {
			// setBankAddress(value);
			Util.verifyAlphabet(value)
				? setBankAddress(value)
				: setBankAddress(bankAddress);
		}

		if (name === "zipCode") {
			Util.alphaNumeric(value) ? setZipCode(value) : setZipCode(zipCode);
		}

		if (name === "bcontactNumber") {
			// setBContactNumber(value);
			Util.verifyMobile(value)
				? setBContactNumber(value)
				: setBContactNumber(bcontactNumber);
		}

		if (name === "isBankDefault") {
			// setIsBankDefault(value);
			setIsBankDefault(value == "Select Status" ? "" : value);
		}
	};

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	// console.log("Curr: ", adminCurrencyList);

	const updateBankDetails = () => {
		setupdatewalletstatus(true);
		const updateWalletOwnerBankViewReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			bankDetailsVO: {
				bankId: "",
				accountHolder: accountHolder,
				accountNumber: accountNumber,
				bankAddress: bankAddress,
				bankContactNo: bcontactNumber,
				bankContactPerson: BcontactPerson,
				bankCountry: bankCountry,
				bankCurrency: currency,
				bankName: BankName,
				bankZip: zipCode,
				ibanNumber: IBANNumber,
				ifscCode: SFBCode,
				isBankDefault: isBankDefault,
				routingCode: routingCode,
				sortCode: sortCode
			}
		};

		return dispatch(
			updateWalletDetailsReq(updateWalletOwnerBankViewReq, authToken)
		);
	};

	const updateoraddwalletownerbankdetailsRes = useSelector(
		({ updateoraddwalletownerbankdetails }) => updateoraddwalletownerbankdetails
	);

	const handleClose = () => {
		setupdatewalletpopup(false);
	};

	useEffect(() => {
		if (updatewalletstatus) {
			if (updateoraddwalletownerbankdetailsRes.data.status == "success") {
				setUpdateoraddwalletownerArray(
					updateoraddwalletownerbankdetailsRes.data
				);
				setupdatewalletpopup(true);
			}
			if (updateoraddwalletownerbankdetailsRes.data.status == "Failed") {
				setUpdateoraddwalletownerArray(
					updateoraddwalletownerbankdetailsRes.data
				);
				setupdatewalletpopup(true);
				if (
					updateoraddwalletownerbankdetailsRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateoraddwalletownerbankdetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateoraddwalletownerbankdetailsRes.data.status == "failed") {
				setUpdateoraddwalletownerArray(
					updateoraddwalletownerbankdetailsRes.data
				);
				setupdatewalletpopup(true);
				if (
					updateoraddwalletownerbankdetailsRes.data.description ==
					"session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateoraddwalletownerbankdetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	}, [updateoraddwalletownerbankdetailsRes.data.status]);

	return (
		<Layout>
			<BackButton />
			<Card>
				<Grid container style={{ padding: "10px" }}>
					<Grid item xs={12} md={2} lg={2}></Grid>

					<Grid item xs={12} md={8} lg={8}>
						<div style={{ marginTop: "1.5rem" }}>
							{" "}
							<TextField
								name="BankName"
								margin="dense"
								label="Bank Name"
								type="name"
								required
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={BankName || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>
						<div style={{ marginTop: "1.5rem" }}>
							{" "}
							<TextField
								select
								margin="dense"
								label="Currency"
								name="currency"
								type="text"
								required
								fullWidth
								variant="standard"
								onChange={handleChange}
								//value={currency || ""}
								defaultValue={"Select Currency" || currency}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</div>
						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								name="accountNumber"
								margin="dense"
								label="Account Number"
								type="name"
								fullWidth
								required
								variant="standard"
								onChange={handleChange}
								value={accountNumber || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>
						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="SWIFT/IFSC/BIC Code"
								type="text"
								fullWidth
								required
								name="SFBCode"
								variant="standard"
								onChange={handleChange}
								value={SFBCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>
						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="Sort Code"
								name="sortCode"
								type="text"
								fullWidth
								required
								variant="standard"
								onChange={handleChange}
								value={sortCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="ABA Routing Code(US)"
								type="text"
								fullWidth
								required
								name="routingCode"
								variant="standard"
								onChange={handleChange}
								value={routingCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						<div style={{ marginTop: "1.5rem" }}>
							{" "}
							<TextField
								margin="dense"
								label="IBAN Number"
								name="IBANNumber"
								type="text"
								fullWidth
								required
								variant="standard"
								onChange={handleChange}
								value={IBANNumber || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						<div style={{ marginTop: "1.5rem" }}>
							{" "}
							<TextField
								margin="dense"
								label="Account Holder"
								type="text"
								required
								name="accountHolder"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={accountHolder || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="Bank Country"
								name="bankCountry"
								type="text"
								required
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={bankCountry || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>
						<div style={{ marginTop: "1.5rem" }}>
							{" "}
							<TextField
								margin="dense"
								label="Bank Address"
								type="text"
								name="bankAddress"
								required
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={bankAddress || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>
						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="Bank Zip Code"
								name="zipCode"
								required
								onChange={handleChange}
								type="text"
								fullWidth
								variant="standard"
								value={zipCode || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						{/* <div style={{ marginTop: "1.5rem" }}>
            <Typography variant="body1" align="justify" gutterBottom={true}>
              State:
            </Typography>
            <TextField
              size="small"
              color="primary"
              type="string"
              // label="state"
              variant="outlined"
              fullWidth={true}
              name="state"
              value={state}
              onChange={(e) => onInputChange(e)}
            />
          </div> */}

						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="Bank Contact Number"
								required
								type="text"
								name="bcontactNumber"
								fullWidth
								variant="standard"
								onChange={handleChange}
								value={bcontactNumber || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								margin="dense"
								label="Bank Contact Person"
								type="text"
								fullWidth
								required
								name="BcontactPerson"
								variant="standard"
								onChange={handleChange}
								value={BcontactPerson || ""}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</div>

						<div style={{ marginTop: "1.5rem" }}>
							<TextField
								select
								margin="dense"
								label="Is Bank Default"
								name="isBankDefault"
								required
								type="text"
								fullWidth
								variant="standard"
								onChange={handleChange}
								defaultValue={isBankDefault || "Select Status"}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Status">Select Status</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</div>

						<div className="text-center" style={{ marginTop: "2.5rem" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateBankDetails}
							>
								Submit
							</CustomButton>
						</div>
					</Grid>

					<Grid item xs={12} md={2} lg={2}></Grid>
				</Grid>
			</Card>

			{updatewalletpopup && (
				<div>
					<Dialog open={updatewalletpopup} onClose={handleClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							{updateoraddwalletownerArray.status == "success" ? (
								<img src={success} alt="" width="100px" className="my-2" />
							) : (
								<img src={failed} alt="" width="100px" className="my-2" />
							)}
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								{updateoraddwalletownerArray.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</Layout>
	);
};

export default AddBankDetails;
